// The email/mail API is authed with the main identity JWT, so it uses the shared
// email client from http.js (same request/refresh interceptors as the main API).
// This mirrors whise-mobile-ionic, where both clients come from one factory and
// there is no separate password-derived email token.
import { emailClient } from './http';

export default emailClient;
